import React from 'react';
import styles from '../assets/styles/PasswordReset.module.scss';

const CompletedResetPassword = () => {
  const handleLoginPage = () => {
    window.location.href = '/login';
  };

  return (
    <div className={styles.containerWrap}>
      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>

      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.formArea}>
              <img src="/images/logo_aibex_line_b.svg" alt="AI-BEX" className={styles.logo} />

              <div className={styles.successMessageContainer}>
                <p className={styles.successMessage}>パスワードの再設定が<br />完了しました。</p>
              </div>

              <form onSubmit={(e) => e.preventDefault()}>
                <button type="button" onClick={handleLoginPage}>
                  ログインへ
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletedResetPassword;
